<template>
  <div>
    <PageTitle title="Master Data" />
    <v-container fluid class="lighten-12">
      <v-row>
        <v-col cols="12" md="12" class="pa-3">
          <v-card class>
            <v-tabs v-model="tab" background-color="white" color="primary" slider-color="primary">
              <v-tabs-slider></v-tabs-slider>
              <v-tab v-for="item in items" :key="item.tab">
                {{ item.tab }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="item in items" :key="item.tab">
                <!-- <Incredient v-if="item.tab === 'Incredients'"  /> -->
                <Brands v-if="item.tab === 'Brands'" />
                <Categories v-if="item.tab === 'Categories'" />
                <Units v-if="item.tab === 'Units'" />
                <BookingStatus v-if="item.tab === 'Booking Status'" />

                <Expensecategory v-if="item.tab === 'Expense Category'"  />
                <Incomecategory v-if="item.tab === 'Income Category'" />
                <!-- <Places v-if="item.tab === 'Places'" /> -->
                 <WareHouese v-if="item.tab === 'Warehouse'" />
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Incredient from "./Incredients/IncredientComponent";
import Categories from "../../shared/settings/productCategory/components/CategoryList";
import Units from "../../shared/settings/Units/components/UnitList";
import BookingStatus from "../../shared/settings/BookingStatus/components/BookingStatusList";
import Brands from "../../shared/settings/brand/BrandListComponent";
import Places from "@/modules/Places/Components/place.vue";
import Expensecategory from "../../shared/settings/ExpenseCategory/components/ExpenseCategoryList";
import Incomecategory from "../../shared/settings/IncomeCategory/components/IncomeCategoryList";
import WareHouese from "../../shared/settings/Warehouse/components/WareHouseList";
export default {
  data() {
    return {
      items: [
        // { tab: "Incredients", content: "" },
        { tab: "Brands", content: "this is credit tab" },
        { tab: "Categories", content: "this is credit tab" },
        { tab: "Units", content: "this is credit tab" },
        { tab: "Booking Status", content: "booking status tab" },

        { tab: "Expense Category", content: "this is credit tab" },
        { tab: "Income Category", content: "income category tab" },
         { tab: "Warehouse", content: "this is credit tab" },
      ],
      tab: "Credit",
    };
  },
  components: {
    Incredient,
    Categories,
    Units,
    BookingStatus,
    Brands,
    Expensecategory,
    Incomecategory,
    Places,
    WareHouese
  },
};
</script>
